function FlowNode({
  label,
  color,
  small,
}: {
  label: string;
  color: "blue" | "purple";
  small?: boolean;
}) {
  const base =
    color === "blue"
      ? "bg-blue-50 border-blue-200 text-blue-800"
      : "bg-purple-50 border-purple-200 text-purple-800";
  return (
    <div
      className={`border rounded-lg px-3 py-2 ${small ? "text-xs" : "text-sm"} font-medium ${base} whitespace-nowrap`}
    >
      {label}
    </div>
  );
}

function Arrow({ color }: { color: "blue" | "purple" }) {
  const c = color === "blue" ? "text-blue-400" : "text-purple-400";
  return (
    <span className={`${c} text-lg font-bold flex-shrink-0 mx-1`}>
      &rarr;
    </span>
  );
}

function DownArrow({ color }: { color: "blue" | "purple" }) {
  const c = color === "blue" ? "text-blue-400" : "text-purple-400";
  return (
    <span className={`${c} text-lg font-bold block text-center`}>
      &darr;
    </span>
  );
}

function UpArrow({ color }: { color: "blue" | "purple" }) {
  const c = color === "blue" ? "text-blue-400" : "text-purple-400";
  return (
    <span className={`${c} text-lg font-bold block text-center`}>
      &uarr;
    </span>
  );
}

export default function ModelArchitectureDiagram() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-2">
        <div className="w-2 h-2 bg-gray-500 rounded-full" />
        모델 아키텍처
      </h3>

      <div className="space-y-8">
        {/* SmilesMatcher */}
        <div>
          <h4 className="text-sm font-semibold text-blue-700 mb-3">
            SmilesMatcher (JSD 기반 화합물 동정)
          </h4>
          <div className="flex flex-col items-center gap-1">
            {/* Main flow */}
            <div className="flex items-center gap-1 flex-wrap justify-center">
              <FlowNode label="입력 스펙트럼" color="blue" />
              <Arrow color="blue" />
              <FlowNode label="확률분포 정규화" color="blue" />
              <Arrow color="blue" />
              <FlowNode label="JSD 거리 계산" color="blue" />
              <Arrow color="blue" />
              <FlowNode label="Top-K 랭킹" color="blue" />
              <Arrow color="blue" />
              <FlowNode label="화합물 동정" color="blue" />
            </div>
            {/* Reference DB annotation */}
            <div className="flex flex-col items-center mt-1">
              <UpArrow color="blue" />
              <FlowNode
                label="참조 DB: 142 화합물"
                color="blue"
                small
              />
            </div>
          </div>
        </div>

        <hr className="border-gray-200" />

        {/* KROVEX */}
        <div>
          <h4 className="text-sm font-semibold text-purple-700 mb-3">
            KROVEX (GCN + Bilinear Fusion 물성 예측)
          </h4>
          <div className="flex flex-col items-center gap-1">
            {/* Input */}
            <div className="flex items-center gap-1 flex-wrap justify-center">
              <FlowNode label="SMILES" color="purple" />
              <Arrow color="purple" />
              <FlowNode label="RDKit 그래프" color="purple" />
              <Arrow color="purple" />
              <FlowNode label="원자 특성 8차원" color="purple" />
            </div>
            <DownArrow color="purple" />
            {/* GCN layers */}
            <div className="flex items-center gap-1 flex-wrap justify-center">
              <FlowNode label="GCN 8->100->20" color="purple" />
              <Arrow color="purple" />
              <FlowNode label="Mean Pool" color="purple" />
              <Arrow color="purple" />
              <FlowNode label="Bilinear Fusion" color="purple" />
              <Arrow color="purple" />
              <FlowNode label="MLP 128->32->1" color="purple" />
              <Arrow color="purple" />
              <FlowNode label="예측값" color="purple" />
            </div>
            {/* Descriptor annotation */}
            <div className="flex flex-col items-center mt-1">
              <UpArrow color="purple" />
              <FlowNode
                label="RDKit 기술자 23/30개"
                color="purple"
                small
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
